import jwtAuthAxios from "../auth/jwtAuth";

// Lista unificada de Automatizaciones: todos los tipos (reglas, controles «Mantener en rango»…) en una sola respuesta.
const automationServices = {};

automationServices.getAutomations = async (params = {}) => {
    const { data } = await jwtAuthAxios.get("/automations/automation_items", { params });
    return data;
};

automationServices.getAutomationGroups = async () => {
    const { data } = await jwtAuthAxios.get("/automations/automation_items/groups");
    return data?.groups || [];
};

// Cambia la carpeta de una automatización (group vacío = «Sin agrupar»).
automationServices.moveAutomation = async (item, group) => {
    const { data } = await jwtAuthAxios.post("/automations/automation_items/move", { type: item.type, id: item.id, group: group || "" });
    return data;
};

// Cambios a reglas que un asistente propuso por la API o el MCP y que bajan su protección: se aplican o se rechazan.
automationServices.getRuleChangeProposals = async () => {
    const { data } = await jwtAuthAxios.get("/automations/rule_change_proposals");
    return data?.data || [];
};

automationServices.applyRuleChangeProposal = async (id) => {
    const { data } = await jwtAuthAxios.post(`/automations/rule_change_proposals/${id}/apply`, {}, { silentErrors: true });
    return data;
};

automationServices.rejectRuleChangeProposal = async (id) => {
    const { data } = await jwtAuthAxios.post(`/automations/rule_change_proposals/${id}/reject`, {}, { silentErrors: true });
    return data;
};

export default automationServices;
